import React from "react";
import PropTypes from "prop-types";

const CollectionSearchError = props => (
    <section className="search-error-msg">
        <p>
            The number entered is not a valid ISBN number.<br />
            The ISBN-10 or ISBN-13 should only have the numbers, with no dashes or spaces, for example:
            <br />
            <b>"9781234567</b>
            " or "
            <b>9781234567890"</b>
        </p> 
    </section>
);

CollectionSearchError.propTypes = {
    text: PropTypes.string,
    isDark: PropTypes.bool
};

CollectionSearchError.defaultProps = {
    text: "Loading...",
    isDark: true
};

export default CollectionSearchError;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/CollectionSearchError.js